import produce from 'immer';
import {
  GET_ASSET_MANAGER_CATEGORY_TAGS_START,
  GET_ASSET_MANAGER_CATEGORY_TAGS_SUCCESS,
  GET_ASSET_MANAGER_CATEGORY_TAGS_FAILED,
  GET_ASSET_MANAGER_IMAGES_START,
  GET_ASSET_MANAGER_IMAGES_SUCCESS,
  GET_ASSET_MANAGER_IMAGES_FAILED,
  UPLOAD_PROVIDER_IMAGE_START,
  UPLOAD_PROVIDER_IMAGE_SUCCESS,
  UPLOAD_PROVIDER_IMAGE_FAILED,
  UPLOAD_PRIVATE_IMAGE_START,
  UPLOAD_PRIVATE_IMAGE_SUCCESS,
  UPLOAD_PRIVATE_IMAGE_FAILED,
  GET_ASSET_MANAGER_TAG_BY_CODE_START,
  GET_ASSET_MANAGER_TAG_BY_CODE_SUCCESS,
  GET_ASSET_MANAGER_TAG_BY_CODE_FAILED
} from '../actions/asset_manager';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  assetImagesData: {},
  assetCategoryTags: [],
  emailStylesTags: [],
  currentCategoryId: null,
  privateTagId: null,
  providerUploadedImageData: {},
  loadingAssetImagesData: false,
  loadingAssetCategoryTags: false,
  uploadingProviderImage: false,
  uploadingPrivateImage: false
};

const formReducer = produce((state: IAssetManagerState = initialState, action) => {
  switch (action.type) {
    case GET_ASSET_MANAGER_IMAGES_START: {
      state.loadingAssetImagesData = true;
      break;
    }
    case GET_ASSET_MANAGER_IMAGES_SUCCESS: {
      const {data, tagId, isPrivate} = action;

      const items = isPrivate
        ? data.items
        : data.items.filter((item) => {
          const tagsCodes = item.tags.map((tag) => tag.tagCode);
          return !tagsCodes.includes('private');
        });

      state.assetImagesData = {
        ...state.assetImagesData,
        [tagId]: {
          items,
          page: data.page,
          total: data.total,
          limit: data.limit
        }
      };

      state.loadingAssetImagesData = false;

      break;
    }
    case GET_ASSET_MANAGER_IMAGES_FAILED: {
      state.loadingAssetImagesData = false;
      break;
    }
    case GET_ASSET_MANAGER_CATEGORY_TAGS_START: {
      state.loadingAssetCategoryTags = true;
      break;
    }
    case GET_ASSET_MANAGER_CATEGORY_TAGS_SUCCESS: {
      const {data, currentCategoryData: {id}} = action;

      state.currentCategoryId = id;
      state.assetCategoryTags = data.items;
      state.emailStylesTags = data.items.reduce((acc, item) => {
        if (/style-[0-9]+/.test(item.tagCode)) {
          return [...acc, {name: item.label, value: item.tagCode}];
        }

        return acc;
      }, []).sort((a, b) => {
        return a.value.split('-')[1] - b.value.split('-')[1];
      });
      state.privateTagId = data.items.find((item) => item.label.toLowerCase() === 'private')?.id;
      state.loadingAssetCategoryTags = false;

      break;
    }
    case GET_ASSET_MANAGER_CATEGORY_TAGS_FAILED: {
      state.loadingAssetCategoryTags = false;
      break;
    }
    case GET_ASSET_MANAGER_TAG_BY_CODE_START: {
      state.loadingAssetCategoryTags = true;
      break;
    }
    case GET_ASSET_MANAGER_TAG_BY_CODE_SUCCESS: {
      // Merge the fetched tag into assetCategoryTags if not already present
      const tag: IAssetCategoryTag = action.data;
      const exists = state.assetCategoryTags.some((t) => t.tagCode === tag.tagCode);

      if (!exists) {
        state.assetCategoryTags = [...state.assetCategoryTags, tag];
      }

      state.loadingAssetCategoryTags = false;
      break;
    }
    case GET_ASSET_MANAGER_TAG_BY_CODE_FAILED: {
      state.loadingAssetCategoryTags = false;
      break;
    }
    case UPLOAD_PROVIDER_IMAGE_START: {
      state.uploadingProviderImage = true;
      break;
    }
    case UPLOAD_PROVIDER_IMAGE_SUCCESS: {
      const {data} = action;

      state.providerUploadedImageData = data.result;
      const tags = data.result.tags.map((tag) => tag.id).join(', ');

      state.assetImagesData[tags] = state.assetImagesData[tags] ?
        {
          ...state.assetImagesData[tags],
          items: [...state.assetImagesData[tags].items, data.result]
        }
        : {items: [data.result]};

      state.uploadingProviderImage = false;

      break;
    }
    case UPLOAD_PROVIDER_IMAGE_FAILED: {
      state.uploadingProviderImage = false;
      break;
    }
    case UPLOAD_PRIVATE_IMAGE_START: {
      state.uploadingPrivateImage = true;
      break;
    }
    case UPLOAD_PRIVATE_IMAGE_SUCCESS: {
      const {data} = action;

      const tags = data.result.tags.map((tag) => tag.id).join(', ');

      state.assetImagesData[tags] = state.assetImagesData[tags] ?
        {
          ...state.assetImagesData[tags],
          items: [...state.assetImagesData[tags].items, data.result]
        }
        : {items: [data.result]};

      state.uploadingPrivateImage = false;

      break;
    }
    case UPLOAD_PRIVATE_IMAGE_FAILED: {
      state.uploadingPrivateImage = false;
      break;
    }
    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.assetCategoryTags = [];

      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
